export const colors = {
	main: '#6B32B5',
	main2: '#9747FF',
	main3: '#9747FF',
	main_50: '#F5EDFF',
	main_100: '#DFC6FF',

	white: '#FFFFFF',
	white2: '#DFE9F4',

	black: '#1B1B1B',
	black2: '#01234A',

	lightBlue: '#E6F0FB',
	lightBlue2: '#D9E8F8',
	blue: '#0267D9',
	blue2: '#025ABD',

	grey: '#3D3D3D',
	grey1: '#6A6A6A',
	grey3: '#ADADB2',
	grey4: '#ECECEC',
	grey5: '#E2E2E2',
	grey6: '#2E2E2E',
	grey7: '#7B7B7B',
	grey8: '#DDDDDD',

	red: '#DD2A2B',
	lightRed: '#F4BDBD',

	orange: '#DD2A2B',

	canvas1: '#EAEAEC',

	green: '#5AC9AE',
	green2: '#25C548',
	lightGreen: '#BBEDC6',
	greenLight: '#E9F9ED',

	red2: '#F18989',
	purple: '#B29EE5',
	blue3: '#85B0DC',
	blue4: '#DFE9F4',
	blue5: '#0264D2',

	yellow: '#F8A70D',
	yellow2: '#F5890D',
	lightYellow: '#FCDAB4',
	yellow3: '#E7C516',

	darkBlue: '#012D5E',
	borderBlue: '#B1CFF1',
	borderRed: '#F4BDBD',
	borderGrey: '#00000045',
	disabledGrey: '#6A6A6A',
	borderGrey2: '#E0E0E0',
	ceruleanBlue: '#024B9E',
	richBlack: '#08091D',

	grey_20: '#F5F5F5',
	grey_30: '#F6F6F6',
	grey_50: '#E9E9E9',
	grey_100: '#BABABA',
	grey_150: '#B3B1B6',
	grey_200: '#999999',
	grey_300: '#6B6B6B',
	grey_400: '#4E4E4E',
	grey_500: '#222222',
	grey_600: '#E6E7E7',

	alert1: '#E83345',
	alert2: '#E76060',
}
